import SynthesesConsoClientController from './syntheses-conso-client.controller';

export default {
    template: require('./syntheses-conso-client.tpl.html'),
    controller: SynthesesConsoClientController
};
